import styled from '@emotion/styled';
import { css } from '@emotion/react';

const arrowRightStyles = () => css`
  content: '';
  position: absolute;
  top: 0;
  left: 100%;
  border: 24px solid transparent;
  border-right-width: 0;
  border-left-width: 20px;
  border-top-width: 25px;
  border-bottom-width: 25px;
`;

const getStepBackground = ({ active, completed, theme }) => {
  if (active) {
    return theme.colors.actionStrong;
  } else if (completed) {
    return theme.colors.primary;
  } else {
    return '#edeff0';
  }
};

const getTextColor = ({ active, completed, theme }) =>
  active || completed ? theme.colors.textLight : theme.colors.textDark;

export const Step = styled.div`
  position: relative;
  width: 170px;
  height: 50px;

  font-family: ${({ theme }) => theme.fonts.secondary};
  margin-right: 0.29rem;

  &::after {
    ${arrowRightStyles};
    border-left-color: white;
    transform: translateX(4px);
    z-index: 1;
  }
`;

export const StepContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

  background-color: ${getStepBackground};
  border-color: ${getStepBackground};
  color: ${getTextColor};
  cursor: ${({ active, completed, clickable }) =>
    clickable && (active || completed) ? 'pointer' : 'not-allowed'};

  svg {
    width: 20px;
    height: 20px;
    margin-right: 1rem;
    margin-left: 3.4rem;

    path {
      fill: ${({ completed, theme }) =>
        completed ? theme.colors.textLight : theme.colors.textDark};
    }
  }

  .progress-tracker-content {
    flex: 1;
    opacity: ${({ clickable }) => (clickable ? 1 : 0.7)};
  }

  .progress-tracker-content-hover {
    flex: 1;
    font-size: 0.65rem;
    display: none;
  }

  &:hover {
    .progress-tracker-content {
      display: ${({ hoverable }) => (hoverable ? 'none' : 'inline')};
    }

    .progress-tracker-content-hover {
      display: inline;
    }
  }

  &::after {
    ${({ arrowRight }) => (arrowRight ? arrowRightStyles : '')}
    border-left-color: ${getStepBackground};
    z-index: 2;
  }

  &:last-child svg {
    margin-left: 3rem;
  }
`;

export const StepsWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 1.5rem 0;
`;
